<template>
  <form @submit.prevent="save">
    <div class="columns">
      <div class="column">
        <div class="has-background-white rounded-xl">
          <!-- Loaded -->
          <div class="pa-lg pb-xl">
            <div class="mb-lg">
              <p class="has-text-weight-bold mb-xs">MSRP Cost Formula</p>
              <div class="has-text-grey is-size-7">
                <p class="mb-md">
                  The MSRP Cost Formula determines how the MSRP (Manufacturer's Suggested Retail Price)
                  is used to calculate the cost price for products from the supplier.
                  This is useful when you want to set your cost price as a percentage of the MSRP.
                </p>
                <p class="mb-md">
                  For example, if you set the formula to "0.8 * msrp", and the MSRP of a product is $100,
                  then the cost price will be calculated as $80.
                </p>
                <p class="mb-md">
                  You can use standard mathematical operations and functions in the formula.
                  Ensure that the formula is valid and returns a numerical value.
                </p>
              </div>
            </div>
            <div>
              <p class="has-text-weight-bold mb-md"></p>
              <b-field :type="showError ? 'is-danger' : ''" label="MSRP Cost Formula" :message="showError ? 'Please enter a valid formula that includes msrp.' : ''">
                <b-input type="text" v-model="value" @input="isDirty = 1" placeholder="e.g., 0.8 * msrp"></b-input>
              </b-field>
            </div>
          <div class="border-t">
            <div class="columns is-vcentered is-marginless">
              <div class="column is-hidden-mobile">
                <div class="px-sm has-text-grey-light">
                  <i v-if="isDirty">Click 'Save Preference' to save your changes</i>
                </div>
              </div>
              <div class="column is-narrow">
                <div class="px-sm">
                  <b-button
                    native-type="submit"
                    type="is-primary rounded-lg"
                    :disabled="!ready || saving || !isDirty"
                  >Save Preference</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </form>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return this.context.route + '/retailer-preferences/'
    },
    json () {
      return {
        preference: { id: this.preference.id },
        value: this.value.replaceAll(/\s/g, '') // Remove whitespace for validation
      }
    },
    hasValidPattern () {
      const regex = /(?:(?:(?:-?\d+(?:\.\d+)?)|[/*()-]+|(?:msrp))[ \t]*)+/
      return this.value && this.value.includes('msrp') && regex.test(this.value) && this.value.length > 0
    },
    isValidFormula () {
      if (!this.hasValidPattern) return false
      try {
        // Replace 'msrp' with a sample value to test the formula
        const testFormula = this.value.replace(/msrp/gi, '100')
        // Evaluate the formula safely
        // eslint-disable-next-line no-new-func
        return new Function(`"use strict"; return typeof (${testFormula}) === 'number';`)()
      } catch (e) {
        return false
      }
    },
    ready () {
      return this.hasValidPattern && this.isValidFormula
    },
    showError () {
      return this.value !== null && this.value.length > 0 && !this.isValidFormula
    }
  },
  data () {
    return {
      isDirty: false,
      preference: null,
      value: null,
      errors: [],
      saving: false
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http.post(this.endpoint, this.json).then(response => {
        this.isDirty = false
        this.$buefy.toast.open({ type: 'is-success', message: 'Preference updated!' })
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
        }
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  mounted () {
    this.preference = this.$utils.find(this.preferences, ['code', 'msrp_cost_formula'])
    if (typeof this.preference !== 'undefined' && this.preference.retailer_preference) {
      this.value = this.preference.retailer_preference.value || ''
    } else {
      this.value = '' // Default value if preference not found
    }
    this.isDirty = false // Reset dirty state on mount
  },
  props: ['preferences', 'retailerPreferences']
}
</script>
